export default __webpack_public_path__ + "static/keep-ya-mind-sharp_logo-e662b9b33b4020993d9ab14f3268b97d.png";